<template>
  <v-menu>
    <template #activator="{ on }">
      <v-btn icon flat class="ma-0" v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="item in items"
        :key="item.value"
        ripple
        @click="$emit('select', item.value)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { value: 'edit', text: this.$t('edit'), icon: 'edit' },
        { value: 'delete', text: this.$t('Delete'), icon: 'delete' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/my-allianz/LinkManagement/ItemMenu.vue